import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';

import { KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

const initialState = {
	name: null,
	nameError: null,
	email: null,
	emailError: null,
	phone: null,
	phoneError: null,
	comment: null,
	commentError: null,
};
const ThemeEightContactUsScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const [state, setState] = useState(initialState);

	const onChange = (value, type) => {
		if (type == 'phone') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.phone) {
			setState({ ...state, phoneError: true, phoneErrorMessage: 'Ingresa tu número de teléfono' });
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.comment) {
			setState({
				...state,
				commentError: true,
				commentErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};
	const onSubmit = () => {
		if (!validate()) {
			return;
		}


		let data = {
			name: state.name,
			last_name: null,
			email: state.email,
			phone_number: state.phone,
			comments: state.comment,
			operator_id: operator.operator_id,
			operator_name: operator.operator_name,
		};
		props.actions
			.apiCall({
				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
			.then(
				res => onContactInfoResponse(res),
				err => onContactInfoResponse(err),
			);

	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		<div className="themes-theme-eight-contact-us-screen">
			<KuposHelmet />
			<HeroSection
				heroImage={getIcons('contactUsBanner', operator)}
				title="Contacto"
				description="Home / Contacto"
			/>

			<div className="form-section">
				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Nombre</div>
					<KuposInput
						type="text"
						placeholder="Nombre"
						value={state.name}
						error={state.nameError}
						inputOuterStyle={{ border: '1px solid #cccc' }}
						errorMessage={state.nameErrorMessage}
						onChange={val => onChange(val, 'name')}
					/>
				</div>

				<div className="contact-input-item ">
					<div className="contact-input-label less-bold-text ">Teléfono</div>
					<KuposInput
						type="number"
						placeholder="Teléfono"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						value={state.phone}
						error={state.phoneError}
						inputOuterStyle={{ border: '1px solid #cccc' }}
						errorMessage={state.phoneErrorMessage}
						onChange={val => onChange(val, 'phone')}
					/>
				</div>

				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Email</div>
					<KuposInput
						type="email"
						placeholder="Email"
						value={state.email}
						error={state.emailError}
						inputOuterStyle={{ border: '1px solid #cccc' }}
						errorMessage={state.emailErrorMessage}
						onChange={val => onChange(val, 'email')}
					/>
				</div>

				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Comentario</div>
					<textarea
						className="text-area font12 form-group w-100"
						rows={8}
						inputOuterStyle={{ border: '1px solid #cccc' }}
						onChange={e => onChange(e.target.value, 'comment')}
					/>
				</div>

				<style>
					.btn:hover{'{'}
					background: #e84b3f !important;
				</style>

				<div className="contact-input-item center ">
					<button className="btn submit-btn  bold-text" id="submit_btn" style={{
						background:
							operator &&
							operator.color_codes &&
							operator.color_codes.button_color &&
							operator.color_codes.button_color,
						color: 'white',
					}} onClick={() => {
						onSubmit();
					}}>
						ENVIAR
					</button>
					{/* <button
						class="btn submit-btn  bold-text"
						style={{
							background:
								operator &&
								operator.color_codes &&
								operator.color_codes.button_color &&
								operator.color_codes.button_color,
							color: 'white',
						}}
					>
						ENVIAR
					</button> */}
					<KuposErrorSuccessModal
						success={state.status == 200 ? true : false}
						showModal={state.showModal}
						onButtonClick={() => {
							setState({ showModal: false });
							window.location.reload();
						}}
						bodyText={state.responseMessage}
					/>
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions, ...commonActions }, dispatch),
	};
}


export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeEightContactUsScreen));



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEight/ThemeEightPages/ThemeEightContactUsScreen.js